const MONTHS_SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const MONTHS_LONG  = ['January','February','March','April','May','June',
                      'July','August','September','October','November','December'];

/**
 * Format a YYYY-MM-DD string to "DD MMM YYYY" for Australian display.
 * e.g. "2025-03-12" → "12 Mar 2025"
 */
export function formatDate(isoDate) {
  if (!isoDate) return '—';
  const [y, m, d] = isoDate.split('-').map(Number);
  return `${String(d).padStart(2, '0')} ${MONTHS_SHORT[m - 1]} ${y}`;
}

/**
 * Format a YYYY-MM-DD to "Month YYYY" e.g. "April 2026"
 */
export function formatMonthYear(isoDate) {
  if (!isoDate) return '';
  const [y, m] = isoDate.split('-').map(Number);
  return `${MONTHS_LONG[m - 1]} ${y}`;
}

/**
 * Format a number as AUD currency.
 * e.g. 1200 → "$1,200.00"
 */
export function formatCurrency(amount) {
  if (amount == null) return '—';
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 2,
  }).format(amount);
}

/**
 * Convert a DD/MM/YYYY date input to YYYY-MM-DD for the API.
 */
export function toISODate(ddmmyyyy) {
  if (!ddmmyyyy) return '';
  const parts = ddmmyyyy.split('/');
  if (parts.length !== 3) return ddmmyyyy;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
}

/**
 * Convert a YYYY-MM-DD to the HTML date input format (which is also YYYY-MM-DD).
 */
export function toInputDate(isoDate) {
  return isoDate || '';
}
